import service from '@/services/compras/gastoActivo'

const getDefaultState = () => ({
  gasto: {
    nombre: '',
    descripcion: '',
    tipo: '',
    codigo: '',
    cuentaContable: '',
    unidadMedida: { id: '' },
    codigoMoneda: { id: '' },
    costoUnitarioTotal: 0
  },
  currentRow: null,
  tipos: ['Gasto', 'Activo'],
  lista: [],
  saved: 'null'
})

export const state = () => getDefaultState()

export const mutations = {
  RESET_STATE: state => Object.assign(state, getDefaultState()),
  RESET: state => {
    state.gasto = getDefaultState().gasto
    state.gasto.unidadMedida = {
      annotation: 'Unidad',
      id: '5efcc43a1feb334e4d49338c',
      value: 'Unid'
    }
    state.gasto.codigoMoneda = { id: '5efcc43a1feb334e4d4933f4', value: 'CRC', simbolo: '¢' }
  },
  SET_ROW: (state, row) => (state.currentRow = row),
  SET_LIST: (state, obj) => {
    state.lista = obj
  },
  SET: (state, obj) => {
    state.gasto = obj
    state.saved = true
  },
  UPDATE_LIST: (state, obj) => {
    const nObj = state.lista.find(e => e._id === obj._id)

    if (!nObj) state.lista = [obj, ...state.lista]
    else Object.keys(nObj).forEach(i => (nObj[i] = obj[i]))

    state.saved = true
  },
  DELETE_LIST: (state, { obj }) => {
    state.lista = state.lista.filter(e => e._id !== obj._id)
  },
  SAVE_CHANGES: (state, obj) => {
    // state.gasto = obj
    // state.saved = false
  }
}

export const actions = {
  create: async ({ commit, rootGetters }, input) => {
    if (!input.cuentaContable) delete input.cuentaContable

    return service
      .create({
        ...input,

        costoUnitarioTotal: Number(parseFloat(input.costoUnitarioTotal).toFixed(5)),
        emisor: {
          _id: await rootGetters['facturacion/emisorStore/get_Id']
        }
      })
      .then(result => {
        commit('UPDATE_LIST', {
          ...input,
          _id: result._id
        })

        return result
      })
  },
  delete: ({ commit, rootGetters }, { items }) =>
    service.delete(rootGetters['facturacion/emisorStore/get_Id'], items).then(result => {
      result.forEach(i => {
        if (i.state) commit('DELETE_LIST', { obj: i })
      })
      return result
    }),
  readAllByEmisor: async ({ commit, state, dispatch, rootGetters }, force = false) => {
    if (state.lista.length && !force) return state.lista

    state.lista = []

    return service.readAllByEmisor(rootGetters['facturacion/emisorStore/get_Id']).then(result => {
      commit('SET_LIST', result)

      return result
    })
  },
  readById: async ({ commit }, input) => commit('SET', input),

  saveChanges: ({ commit }, compras) => commit('SAVE_CHANGES', compras)
}
